import React from "react";

const BellIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4551 8C18.4551 6.4087 17.8229 4.88258 16.6977 3.75736C15.5725 2.63214 14.0464 2 12.4551 2C10.8638 2 9.33766 2.63214 8.21244 3.75736C7.08722 4.88258 6.45508 6.4087 6.45508 8C6.45508 15 3.45508 17 3.45508 17H21.4551C21.4551 17 18.4551 15 18.4551 8Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1846 21C14.0088 21.3031 13.7565 21.5547 13.4528 21.7295C13.1492 21.9044 12.805 21.9965 12.4546 21.9965C12.1042 21.9965 11.76 21.9044 11.4564 21.7295C11.1528 21.5547 10.9004 21.3031 10.7246 21"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BellIcon;
